import type { RequestFn } from 'api/useApiRequest';

type NewUploadHubFile = {
  url: string;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
};

type UploadHubFile = NewUploadHubFile & {
  publicId: string;
};

export type UploadHubListItem = UploadHubFile & {
  id: string | number;
  createdAtUtc: string;
  addedByUserFullName: string;
};

export const uploadFiles = (
  request: RequestFn,
  { files, signal }: { files: FileList | File[]; signal?: AbortSignal }
) => {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  return request({
    method: 'post',
    pathname: '/api/user-upload/upload',
    data: formData,
    signal,
  });
};

export const addUploadHubItem = (
  request: RequestFn,
  { files, signal }: { files: NewUploadHubFile[]; signal?: AbortSignal }
) =>
  request({
    method: 'post',
    pathname: '/api/upload-hub/add',
    data: files,
    signal,
  });

export const fetchUploadHubList = (request: RequestFn, { signal }: { signal?: AbortSignal } = {}) =>
  request({
    method: 'get',
    pathname: '/api/upload-hub/list',
    signal,
  });

export const updateUploadHubItem = (
  request: RequestFn,
  { signal, ...data }: { signal?: AbortSignal; [key: string]: unknown }
) =>
  request({
    method: 'put',
    pathname: '/api/upload-hub/update',
    data,
    signal,
  });

export const deleteUploadHubItem = (
  request: RequestFn,
  { id, signal }: { id: string | number; signal?: AbortSignal }
) =>
  request({
    method: 'delete',
    pathname: `/api/upload-hub/delete/${id}`,
    signal,
  });

export type UploadHubBranding = {
  logoUrl: string;
  backgroundColor: string;
};

export const fetchUploadHubBranding = (request: RequestFn, { signal }: { signal?: AbortSignal } = {}) =>
  request({
    method: 'get',
    pathname: '/api/upload-hub/branding',
    signal,
  });

export const updateUploadHubBranding = (
  request: RequestFn,
  { signal, ...data }: UploadHubBranding & { signal?: AbortSignal }
) =>
  request({
    method: 'post',
    pathname: '/api/upload-hub/branding/update',
    data,
    signal,
  });
